import React from "react";
import moment from "moment";
import "moment/locale/es";
import { withTranslation } from "react-i18next";
import {
  LocalStorageService,
  UserService,
  ClientDocument,
  ContractorService,
  CategoryService,
  ClientService
} from "../../../services";
import { DocumentsToRequireView } from "../../views";
import { DocumentsToRequireValidator } from "../../../validators";
import { getNavigatorTimezone } from "../../../utils";
import { ENV } from "pixi.js";

class DocumentsToRequireAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      user: {},
      documents: {
        documentsContractorPhysical: [],
        documentsContractorMoral: [],
        documentsRepsePhysical: [],
        documentsRepseMoral: [],
        documentsContractREPSE: [],
        documentsReportREPSE: [],
        documentsProcedureUser: [],
        documentsSigners: [],
        documentsAssemblies: []
      },
      token: "",
      shouldRefresh: false,
      showDialogYesNo: false,
      dataItemUser: {},
      personTypes: [],
      typeDocuments: [],
      preferenceValue: false,
      selectedFile: null,
      selectedFileName: '',
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      newOptions: []
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  UserService = new UserService(this.url);
  contractorService = new ContractorService(this.url)
  ClientDocument = new ClientDocument(this.url);
  categoryService = new CategoryService(this.url);
  clientService = new ClientService(this.url)
  validators = DocumentsToRequireValidator(this.props.t);
  timezone = getNavigatorTimezone()
  goBackRoute = '/help-desk'

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");

    let clientID = user.userMetaData.userMifirma.clientId;
    try {
      let documentsData = await this.ClientDocument.getClientDocumentA3Cloud(
        clientID,
        this.token
      );

      let documents = documentsData.data.data;

      moment.locale("es");
      documents.map((documento) => {
        documento.newUpdatedDate = `${this.props.t("documentsToRequire.grid.modifiedOn")} ${documento.updatedDate}`;
        documento.activeBtnOne =
          documento.defaultDocument === true ? false : true;
        documento.labelBtnTwo =
          documento.defaultDocument === true
            ? this.props.t("documentsToRequire.grid.detail")
            : this.props.t("documentsToRequire.grid.detailAndEdit");
        if (documento.clientDocumentTypeRequest === null && documento.clientDocumentTypeRequestId === null) {
          documento.clientDocumentTypeRequestId = 0
          documento.clientDocumentTypeRequest = { name: 'Sin definir' }
        }

        return documents;
      });

      documents.documentsContractorPhysical = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY;
      });

      documents.documentsContractorMoral = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY;
      });

      documents.documentsRepsePhysical = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY;
      });

      documents.documentsRepseMoral = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY;
      });

      documents.documentsContractREPSE = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY;
      });

      documents.documentsReportREPSE = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY;
      });

      documents.documentsProcedureUser = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY;
      });

      documents.documentsSigners = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_SIGNERS_KEY;
      });

      documents.documentsAssemblies = documents.filter((document) => {
        return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY;
      });

      this.getPersonType()
      this.getDocumentTypes()
      this.getPreferences()
      this.getAllClientDocumentTypeRequest()

      this.setState({
        documents: {
          documentsContractorPhysical: documents.documentsContractorPhysical,
          documentsContractorMoral: documents.documentsContractorMoral,
          documentsRepsePhysical: documents.documentsRepsePhysical,
          documentsRepseMoral: documents.documentsRepseMoral,
          documentsContractREPSE: documents.documentsContractREPSE,
          documentsReportREPSE: documents.documentsReportREPSE,
          documentsProcedureUser: documents.documentsProcedureUser,
          documentsSigners: documents.documentsSigners,
          documentsAssemblies: documents.documentsAssemblies
        },
        user,
        token: this.token,
      });
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }
  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (
    value,
    message,
    documentsFilteredContractorPhysical,
    documentsFilteredContractorMoral,
    documentsFilteredREPSEPhysical,
    documentsFilteredREPSEMoral,
    documentsFilteredContractREPSE,
    documentsFilteredReportREPSE,
    documentsProcedureUser,
    documentsSigners,
    documentsAssemblies
  ) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            documents: {
              documentsContractorPhysical: documentsFilteredContractorPhysical,
              documentsContractorMoral: documentsFilteredContractorMoral,
              documentsRepsePhysical: documentsFilteredREPSEPhysical,
              documentsRepseMoral: documentsFilteredREPSEMoral,
              documentsContractREPSE: documentsFilteredContractREPSE,
              documentsReportREPSE: documentsFilteredReportREPSE,
              documentsProcedureUser: documentsProcedureUser,
              documentsSigners: documentsSigners,
              documentsAssemblies: documentsAssemblies
            }

          });
          // funcion()
        }, 4000);
      }
    );
  };

  //DialogYesNoHLpure funtion to show o not show
  toggleDialogYesNo = (dataItem, value) => {
    this.setState({
      dataItemUser: dataItem,
      showDialogYesNo: value,
    });
  };

  getPersonType = async () => {
    try {
      let contractorPersonType = await this.contractorService.getPersonTypeByKey('documentType', this.token)
      if (contractorPersonType && contractorPersonType.data && Number(contractorPersonType.statusCode) === 200) {
        let personTypes = contractorPersonType.data

        personTypes.sort((a, b) => a.id - b.id)
        personTypes.map((type) => {
          type.personType = `Para ${type.value}`
          type.name = type.value
          return type
        })

        this.setState({
          personTypes,
          loading: false
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  getDocumentTypes = async () => {
    try {
      const responseDocType = await this.categoryService.getTypeDocuments(this.token, 'Documento');
      if (responseDocType.statusCode == 200 && responseDocType.data) {
        let typeDocumentOptions = responseDocType.data;
        typeDocumentOptions.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        this.setState({
          typeDocuments: typeDocumentOptions
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  getPreferences = async () => {
    try {
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone);
      if (preferences && preferences.data && Number(preferences.statusCode) === 200) {
        let preferenceProcedureUser = preferences.data.find((preference) => preference.preferenceName === process.env.REACT_APP_PREFERENCE_PROCEDURES_CONTROL)
        let preferenceValue = (preferenceProcedureUser) ? preferenceProcedureUser.booleanValue : false
        this.setState({
          preferenceValue
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  handleFile = async (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) return
    this.setState({
      selectedFile: e.target.files[0],
      selectedFileName: e.target.files[0].name,
      errorFile: false,
      colorBorderContainer: "green",
    });

    // Upload the base64 in the state
    let fileBase64 = await this.pdfToBase64(e.target.files[0]);
    let pdfBase64 = fileBase64.split(",")[1];
    this.setState({ selectedFileBase64: pdfBase64 });
  };

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
    });
    return true;
  };

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    }
    );

  getAllClientDocumentTypeRequest = async () => {
    try {
      let clientDocumentsTypes = await this.ClientDocument.getAllClientDocumentTypeRequest(this.token)
      if (!clientDocumentsTypes || !clientDocumentsTypes.data || Number(clientDocumentsTypes.statusCode) !== 200) throw new Error('Ocurrió un error al consultar la clasficación de documentos')

      let typesClientDocuements = clientDocumentsTypes.data.map((type) => {
        type.name = this.props.t(`documentsToRequire.typeRequest.name.${type.name}`)
        type.value = type.id
        return type
      })

      this.setState({
        newOptions: typesClientDocuements
      })
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }


  render() {
    return (
      <DocumentsToRequireView
        {...this.state}
        history={this.props.history}
        validators={this.validators}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleDialogYesNo={this.toggleDialogYesNo}
        handleDeleteFile={this.handleDeleteFile}
        handleFile={this.handleFile}
        goBackRoute={this.goBackRoute}
      />
    );
  }
}

export default withTranslation()(DocumentsToRequireAction);
